import socket from "./socket";

export default class Connection {
  static connection = socket;
}
